import {
  PlainSelectTrigger,
  Select,
  SelectContent,
  SelectItem,
} from '@/shadcn-ui/select';
import FilterPill, { FilterPillProps } from '../filter-pill';
import { cn } from '@/shadcn-ui/utils';

export interface FilterPillSelectOption {
  id: string;
  display_name: string;
}

interface FilterPillSelectProps extends Pick<FilterPillProps, 'dark' | 'text' | 'icon'> {
  // Select props
  defaultValue: string;
  onValueChange: (value: string) => void;
  name: string;
  disabled?: boolean;
  options: FilterPillSelectOption[];
  selectContentClassName?: string;

  // FilterPill props
  pillClassName?: string;
}

export default function FilterPillSelect({
  defaultValue,
  onValueChange,
  name,
  disabled,
  options,
  selectContentClassName,
  pillClassName,
  dark,
  text,
  icon,
}: FilterPillSelectProps) {
  return (
    <Select
      defaultValue={defaultValue}
      onValueChange={onValueChange}
      name={name}
      disabled={disabled}
    >
      <PlainSelectTrigger>
        <FilterPill
          icon={icon}
          text={text}
          className={cn('rounded-lg border-none px-3', pillClassName)}
          dark={dark}
        />
      </PlainSelectTrigger>

      <SelectContent className={selectContentClassName}>
        {options.map((option) => (
          <SelectItem key={option.id} value={option.id}>
            {options.find((a) => a.id === option.id)?.display_name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
